/* eslint-disable @typescript-eslint/indent */
/* eslint-disable indent */
import { Component, OnInit } from '@angular/core';
import { AuthService } from '@/auth/service/auth.service';
import { StoreState } from '@/store';
import { Store } from '@ngrx/store';
import { State } from './duck/reducer';

@Component({
  templateUrl: './auth-failure.component.html',
  styleUrls: ['./auth-failure.component.css'],
})
export class AuthFailureComponent implements OnInit {

  state?: State;

  constructor(
    private auth: AuthService,
    private store: Store<StoreState>,
  ) { }

  ngOnInit(): void {
    this.store.select('pageError').subscribe({
      next: (state) => {
        this.state = state;
      },
    });
  }

  logout() {
    this.auth.logout();
  }

  downloadErrorLog() {
    return;
    /*
      <div *ngIf="state.buttonAction === 'DOWNLOAD_ERROR_LOG'" class="">
          <div type="button" (click)="downloadErrorLog()" class="btn btn--primary">Descargar detalle del error</div>
        </div>
    */
    const link = document.createElement('a');
    const date = this.state?.errorDetails?.timestamp || new Date();
    link.download = `error_log_${getStringDate(date)}.json`;
    // link.href = `${environment.baseUrl}Document/GetLicensePdf?licenseId=${id}`;
    const theJSON = JSON.stringify(this.state?.errorDetails, null, 4);
    link.href = `data:application/json;charset=UTF-8,${encodeURIComponent(theJSON)}`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  reloadPage() {
    // eslint-disable-next-line no-restricted-globals
    location.reload();
  }
}

const pad2 = (n: any) => (n < 10 ? `0${n}` : n);

const getStringDate = (date: Date) => `${date.getFullYear().toString()
  }-${
  pad2(date.getMonth() + 1)
  }-${
  pad2(date.getDate())
  }_${
  pad2(date.getHours())
  }-${
  pad2(date.getMinutes())
  }-${
  pad2(date.getSeconds(),
  )}`;
